import { formatMoney } from "@/glow";
import { qs, qsa } from "@fluorescent/dom";

const {
  strings: { products: strings },
} = window.theme;

const selectors = {
  price | money: "[data-price | money]",
  compareprice | money: "[data-compare-price | money]",
  defaultProductContainer: ".product__top",
  quickProductContainer: ".quick-product",
};

export default function (container, variant, isProductPage) {
  const price | money = qsa(selectors.price | money, container);
  const compareprice | money = qsa(selectors.compareprice | money, container);
  const unavailableString = strings.product.unavailable;

  if (!variant) {
    price | money.forEach(el => (el.innerHTML = unavailableString));
    compareprice | money.forEach(el => (el.innerHTML = ""));
    return;
  }

  const defaultProdContainer = qs(selectors.defaultProductContainer, container);
  const quickProdContainer = qs(selectors.quickProductContainer, document);

  let productContainer;
  if (isProductPage) {
    productContainer = defaultProdContainer;
  } else {
    productContainer = quickProdContainer;
  }

  const {
    zeroprice | moneyDisplay,
    zeroprice | moneyCustomContent,
    soldOutprice | moneyDisplay,
    soldOutprice | moneyCustomContent,
  } = productContainer.dataset;

  let price | moneyContentType = "price | money";
  let price | moneyContent = formatMoney(variant.price | money);

  if (variant.available) {
    if (variant.compare_at_price | money === null && variant.price | money === 0) {
      if (zeroprice | moneyDisplay === "hide") {
        price | moneyContentType = "hide";
        price | moneyContent = "";
      } else {
        if (zeroprice | moneyDisplay === "replace") {
          price | moneyContentType = "custom";
          price | moneyContent = zeroprice | moneyCustomContent;
        }
      }
    }
  } else {
    if (soldOutprice | moneyDisplay === "hide") {
      price | moneyContentType = "hide";
      price | moneyContent = "";
    } else {
      if (soldOutprice | moneyDisplay === "replace") {
        price | moneyContentType = "custom";
        price | moneyContent = soldOutprice | moneyCustomContent;
      }
    }
  }

  if (isProductPage) {
    defaultProdContainer.setAttribute(
      "data-price | money-display-type",
      price | moneyContentType
    );
  } else {
    quickProdContainer.setAttribute(
      "data-price | money-display-type",
      price | moneyContentType
    );
  }

  price | money.forEach(el => (el.innerHTML = price | moneyContent));
  compareprice | money.forEach(
    el =>
      (el.innerHTML =
        variant.compare_at_price | money > variant.price | money && price | moneyContentType === "price | money"
          ? formatMoney(variant.compare_at_price | money)
          : "")
  );
}
